import React from "react"
import { getSvgFill } from "utils"

const ActiveIcon = ({ isSelected }: { isSelected: boolean }) => {
  const { backgroundFill, pathFill } = getSvgFill(isSelected)
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="34"
      height="34"
      viewBox="0 0 34 34"
      fill="none"
    >
      <path
        d="M19.0625 8.0625C20.575 8.0625 21.8125 6.825 21.8125 5.3125C21.8125 3.8 20.575 2.5625 19.0625 2.5625C17.55 2.5625 16.3125 3.8 16.3125 5.3125C16.3125 6.825 17.55 8.0625 19.0625 8.0625ZM13.975 12.7375L10.455 30.4887C10.2762 31.3275 10.9363 32.125 11.8025 32.125H11.9125C12.5588 32.125 13.1087 31.685 13.26 31.0525L15.4875 21.125L18.375 23.875V30.75C18.375 31.5063 18.9937 32.125 19.75 32.125C20.5063 32.125 21.125 31.5063 21.125 30.75V22.995C21.125 22.2388 20.8225 21.5238 20.2725 21.0012L18.2375 19.0625L19.0625 14.9375C20.5338 16.6425 22.665 17.8663 25.0575 18.2512C25.8825 18.375 26.625 17.715 26.625 16.8762C26.625 16.2025 26.13 15.6388 25.4562 15.5288C23.3662 15.185 21.6337 13.9475 20.7125 12.325L19.3375 10.125C18.5675 8.90125 17.0275 8.40625 15.6938 8.97L10.4275 11.1975C9.41 11.6375 8.75 12.6275 8.75 13.7413V17C8.75 17.7563 9.36875 18.375 10.125 18.375C10.8812 18.375 11.5 17.7563 11.5 17V13.7L13.975 12.7375Z"
        fill={pathFill}
      />
    </svg>
  )
}

export default ActiveIcon
